import { createAsyncThunk } from '@reduxjs/toolkit';
import { AgentAdTransferLog } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindAgentTransferLogs } from './interface';

// Find agent transfer logs
export const findAgentTransferLogs = createAsyncThunk(
  'agentTransferLogs/findAgentTransferLogs',
  async (values: FindAgentTransferLogs, { rejectWithValue }) => {
    try {
      const response = await AgentAdTransferLog.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

